<template>
    <div class="search-passengers-room">
        <!--roomNumber-->
        <div class="p-2">
            <span class="pull-left trash" @click="$emit('remove')" v-if="showDelete">
                <icon-remove-trash />
            </span>
            <h5 class="inline text-orange w-500">
                اتاق {{ index + 1 | persianOrdinal }}
            </h5>
        </div>
        <!--adult-->
        <div class="p-1 clearfix">
            <strong class="w-500 ml-2">
                بزرگسال
            </strong>
            <small class="text-gray">
                (12 سال به بالا)
            </small>
            <div class="pull-left">
                <span class="style-btn-increase inline-block" @click="increasePassenger('adult')" />
                <span class="inline-block mx-1 text-center" style="min-width: 12px;">
                    {{ room.adults.length }}
                </span>
                <span class="style-btn-decrease inline-block" @click="decreasePassenger('adult')" />
            </div>
        </div>
        <!--Child-->
        <div class="p-1 clearfix">
            <strong class="w-500 ml-2">
                کودک
            </strong>
            <small class="text-gray">
                (0 سال تا 12 سال)
            </small>
            <div class="pull-left">
                <span class="style-btn-increase inline-block" @click="increasePassenger('child')" />
                <span class="inline-block mx-1 text-center" style="min-width: 12px;">
                    {{ room.children.length }}
                </span>
                <span class="style-btn-decrease inline-block" @click="decreasePassenger('child')" />
            </div>
        </div>
        <div v-if="room.children.length > 0" class="mt-2 p-1">
            <div class="clearfix mb-2" v-for="(child, i) in room.children" :key="i">
                <small>
                    سن کودک {{ i + 1 | persianOrdinal }}
                </small>
                <div class="pull-left">
                    <select name="age" class="form-control" id="age" v-model="child.age">
                        <option v-for="age in getAges" :key="age" :value="age">
                            {{ age }} تا {{ age+1 }} سال
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// node_modules
import { mapActions } from 'vuex';
// lodash
import range from 'lodash/range';
import '~/scripts/filters/persian-ordinals';
// icons
import IconRemoveTrash from '~/components/icons/IconRemoveTrash';

export default {
    components: {
        IconRemoveTrash,
    },
    props: {
        index: {
            type: Number,
            required: true,
        },
        room: {
            type: Object,
            default: () => ({}),
        },
        showDelete: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        // child max and min age
        getAges (min = 0, max = 12) {
            return range(min, max);
        },
    },
    methods: {
        ...mapActions(['openAlert']),
        increasePassenger (type) {
            this.$emit('increase', {
                index: this.index,
                type: type,
            });
        },
        decreasePassenger (type) {
            this.$emit('decrease', {
                index: this.index,
                type: type,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~vars';

    .search-passengers-room {
        padding: 0 0 20px;

        .trash {
            display: inline-block;
            font-size: 1.2em;
            transition: all 0.2s;
            cursor: pointer;

            &:hover {
                color: $red;
            }

            svg {
                fill: $red;
            }
        }

        &:nth-child(even) {
            background-color: rgba(249, 250, 254, 1);
            margin: 0 -10px;
            padding: 0 10px 20px;
        }

        &--age-text {
            font-size: 0.875em;
        }

        .form-control {
            border: 1px solid $orange;
            border-radius: 3px;
            width: 97px;
            height: 30px;
            float: left;
            padding: 3px 5px;

            &:focus {
                border: 1px solid $orange;
            }
        }
    }

    #age {
        font-size: 12px;
    }
</style>
